<ion-header class="ion-no-border">
  <ion-toolbar color="primary" class="enhanced-toolbar">
    <ion-title class="enhanced-title">
      <ion-icon name="medical-outline" slot="start"></ion-icon>
      Modifica Codice ICD-9
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onClose()" class="close-button">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="enhanced-content">
  <div class="enhanced-form">
    
    <!-- Sezione informazioni -->
    <div class="form-section">
      <div class="info-card">
        <ion-icon name="information-circle-outline" class="info-icon"></ion-icon>
        <div class="info-text">
          <p>Cerca il codice ICD-9 inserendo almeno 3 cifre del codice o 4 caratteri della descrizione</p>
        </div>
      </div>
    </div>
    
    <!-- Sezione ricerca -->
    <div class="form-section" *ngIf="!selectedIcd9">
      <div class="section-header">
        <ion-icon name="search-outline" class="section-icon"></ion-icon>
        <h3>Ricerca Codice ICD-9</h3>
      </div>

      <div class="search-container">
        <ion-item class="enhanced-item search-item" lines="none">
          <ion-label position="stacked" class="enhanced-label">Cerca per Codice o Descrizione</ion-label>
          <ion-textarea
            placeholder="Cerca per codice o descrizione"
            [c3Autocomplete]="autocomplete"
            class="ion-text-uppercase c3-monospace enhanced-input"
            [(ngModel)]="codiceIcd9"
            #inputField
            (ngModelChange)="onQuickFilterChange($event)"
            [ngModelOptions]="{ standalone: true }"
            rows="1"
            auto-grow="true">
          </ion-textarea>
          <ion-spinner slot="end" color="primary" *ngIf="loading$ | async"></ion-spinner>
        </ion-item>

        <c3-autocomplete #autocomplete="c3Autocomplete" class="enhanced-autocomplete">
          <ng-template c3AutocompleteContent>
            <ion-list class="autocomplete-list">
              <ion-list-header *ngIf="listaCodiciIcd9?.length === 0" class="no-results">
                <ion-icon name="search-outline"></ion-icon>
                <ion-label>Nessun codice ICD-9 trovato</ion-label>
              </ion-list-header>
              
              <c3-option *ngFor="let code of listaCodiciIcd9" [value]="code">
                <ion-item button class="icd9-option">
                  <ion-avatar slot="start" class="code-avatar">
                    <ion-icon name="medical"></ion-icon>
                  </ion-avatar>
                  
                  <ion-label class="code-info">
                    <h3>{{ code.description }}</h3>
                    <p class="code-number">ICD-9: {{ code.id }}</p>
                  </ion-label>
                  
                  <ion-icon name="arrow-forward-circle-outline" slot="end" color="primary"></ion-icon>
                </ion-item>
              </c3-option>
            </ion-list>
          </ng-template>
        </c3-autocomplete>
      </div>
    </div>

    <!-- Sezione codice selezionato -->
    <div class="form-section" *ngIf="selectedIcd9">
      <div class="section-header">
        <ion-icon [src]="'notebook-heart' | getIcon" class="section-icon"></ion-icon>
        <h3>Diagnosi Selezionata</h3>
      </div>

      <div class="selected-card">
        <div class="selected-content">
          <ion-avatar class="selected-avatar">
            <ion-icon name="medical"></ion-icon>
          </ion-avatar>
          
          <div class="selected-info">
            <h3>{{ selectedIcd9?.description }}</h3>
            <p class="selected-code">ICD-9: {{ selectedIcd9?.id }}</p>
          </div>
        </div>

        <ion-button 
          fill="outline" 
          color="primary" 
          size="small" 
          (click)="onIcd9Selected(null)"
          class="change-button">
          <ion-icon name="refresh-outline" slot="start"></ion-icon>
          <span>Cambia Codice</span>
        </ion-button>
      </div>
    </div>

  </div>
</ion-content>

<ion-footer class="enhanced-footer">
  <div class="footer-actions">
    <ion-button 
      fill="solid"
      color="primary" 
      [disabled]="(loading$ | async) || !selectedIcd9" 
      (click)="onSubmit()"
      class="save-button">
      <ion-spinner *ngIf="loading$ | async" slot="start"></ion-spinner>
      <ion-icon *ngIf="!(loading$ | async)" name="save-outline" slot="start"></ion-icon>
      Salva Modifiche
    </ion-button>
  </div>
</ion-footer>